(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets-horizontal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xo-facets-horizontal-scroll')) {
    customElements.define(
      'xo-facets-horizontal-scroll',
      class extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('.xo-facets-horizontal__selector');
          this.button = this.querySelector('.xo-facets-horizontal__scroll-button');

          if (!this.scroller || !this.button) return;

          this.handleClick = () => {
            const direction = this.button.dataset.direction;
            const target = direction === 'start' ? this.scroller.firstElementChild : this.scroller.lastElementChild;

            target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: direction });
          };
          this.handleScroll = () => window.requestAnimationFrame(() => this.update());
          this.resizeObserver = new ResizeObserver(() => this.update());

          this.button.addEventListener('click', this.handleClick);
          this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.scroller);
          this.update();
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.handleClick);
          this.scroller?.removeEventListener('scroll', this.handleScroll);
          this.resizeObserver?.disconnect();
        }

        update() {
          const hasOverflow = this.scroller.scrollWidth > this.scroller.clientWidth + 1;
          this.button.hidden = !hasOverflow;

          if (!hasOverflow || !this.scroller.lastElementChild) return;

          const scrollerBounds = this.scroller.getBoundingClientRect();
          const lastItemBounds = this.scroller.lastElementChild.getBoundingClientRect();
          const lastItemIsVisible =
            lastItemBounds.left >= scrollerBounds.left - 1 && lastItemBounds.right <= scrollerBounds.right + 1;
          const direction = lastItemIsVisible ? 'start' : 'end';

          this.button.dataset.direction = direction;
          this.button.setAttribute(
            'aria-label',
            direction === 'start' ? this.button.dataset.previousLabel : this.button.dataset.nextLabel
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-media-carousel"] && !Shopify.designMode) return;
  try {
    function initInstantVariantMediaPreview() {
  if (window.__instantVariantMediaPreviewBound) return;
  window.__instantVariantMediaPreviewBound = true;

  const productDataCache = new WeakMap();
  const prefetchedImages = new Map();

  function getVariantField(target) {
    if (!(target instanceof Element)) return null;
    if (target.matches('.xo-product-variant__inner-value input, .xo-product-variant__inner-value select')) {
      return target;
    }
    const choice = target.closest('.xo-product-variant__inner-value .xo-field-color, .xo-product-variant__inner-value .xo-field-radio');
    return choice && choice.querySelector('input, select');
  }

  function getProductData(productElement) {
    if (productDataCache.has(productElement)) return productDataCache.get(productElement);
    const productDataElement = productElement.querySelector('xo-product-data script[type="application/json"]');
    if (!productDataElement) return null;
    try {
      const productData = JSON.parse(productDataElement.textContent);
      productDataCache.set(productElement, productData);
      return productData;
    } catch (error) {
      return null;
    }
  }

  function getOptionName(field) {
    const name = field.name.replace(/SIGNAL_.+$/, '');
    const optionMatch = name.match(/^options\[(.+?)\]$/);
    return optionMatch ? optionMatch[1] : name;
  }

  function findVariant(productElement, changedField, productData) {
    const selectedOptions = {};
    const selectedFields = productElement.querySelectorAll('.xo-product-variant input:checked, .xo-product-variant select');
    selectedFields.forEach(function(field) {
      selectedOptions[getOptionName(field)] = field.value;
    });
    selectedOptions[getOptionName(changedField)] = changedField.value;

    return productData.variants.find(function(variant) {
      return productData.options.every(function(optionName, index) {
        return String(variant.options[index]) === String(selectedOptions[optionName]);
      });
    });
  }

  function getOptimizedSource(previewSource, mediaCarousel) {
    try {
      const sourceUrl = new URL(previewSource, window.location.origin);
      const isShopifyImage = sourceUrl.hostname.endsWith('cdn.shopify.com') || sourceUrl.pathname.indexOf('/cdn/shop/') !== -1;
      if (isShopifyImage) {
        const gallery = mediaCarousel.querySelector('.product-info-media-carousel__list');
        const displayWidth = gallery ? gallery.clientWidth : 800;
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        const targetWidth = Math.min(1600, Math.max(800, Math.ceil(displayWidth * pixelRatio / 200) * 200));
        sourceUrl.searchParams.set('width', String(targetWidth));
      }
      return sourceUrl.href;
    } catch (error) {
      return previewSource.indexOf('//') === 0 ? window.location.protocol + previewSource : previewSource;
    }
  }

  function showVariantPreview(mediaCarousel, source) {
    const activeSlide = mediaCarousel.querySelector('.product-info-media-carousel__list xo-carousel-slide[xo-active]:not([xo-active="false"])') ||
      mediaCarousel.querySelector('.product-info-media-carousel__list xo-carousel-slide');
    const image = activeSlide && activeSlide.querySelector('.product-info-media-carousel__image img');
    if (!image || image.currentSrc === source || image.src === source) return;

    image.removeAttribute('srcset');
    image.setAttribute('xo-src', source);
    image.src = source;
    image.loading = 'eager';
    image.fetchPriority = 'high';
    mediaCarousel.setAttribute('data-variant-previewing', 'true');
  }

  function prepareVariantPreview(field, showImmediately) {
    if (!field || field.closest('[xo-disabled]:not([xo-disabled="false"])')) return;
    const productElement = field.closest('xo-product[xo-product-information]');
    if (!productElement) return;
    const productData = getProductData(productElement);
    if (!productData) return;
    const variant = findVariant(productElement, field, productData);
    const previewImage = variant && (variant.featured_image || (variant.featured_media && variant.featured_media.preview_image));
    const previewSource = previewImage && (previewImage.src || previewImage.url);
    if (!previewSource) return;
    const mediaCarousel = productElement.querySelector('.product-info-media-carousel');
    if (!mediaCarousel) return;
    const source = getOptimizedSource(previewSource, mediaCarousel);

    if (!prefetchedImages.has(source)) {
      const prefetchedImage = new Image();
      prefetchedImage.decoding = 'async';
      prefetchedImage.fetchPriority = 'high';
      prefetchedImage.src = source;
      prefetchedImages.set(source, prefetchedImage);
    }
    if (showImmediately) showVariantPreview(mediaCarousel, source);
  }

  document.addEventListener('pointerover', function(event) {
    prepareVariantPreview(getVariantField(event.target), false);
  }, { passive: true });

  document.addEventListener('pointerdown', function(event) {
    prepareVariantPreview(getVariantField(event.target), true);
  }, { passive: true });

  document.addEventListener('change', function(event) {
    prepareVariantPreview(getVariantField(event.target), true);
  });
}

initInstantVariantMediaPreview();

// Video Review - Modal player handling (xo-carousel handles the slider)
document.addEventListener('DOMContentLoaded', function() {
  const videoItems = document.querySelectorAll('.product-video-reviews .video-item');
  if (!videoItems.length) return;
  
  // Video Modal handling
  const videoModal = document.getElementById('videoReviewModal');
  const videoModalContent = document.getElementById('videoModalContent');
  const modalCloseBtn = videoModal ? videoModal.querySelector('.video-modal__close') : null;
  
  // Move modal to body to avoid any parent container stacking context issues
  if (videoModal && videoModal.parentElement !== document.body) {
    document.body.appendChild(videoModal);
  }
  
  function openVideoModal(videoType, videoId, videoElement) {
    if (!videoModal || !videoModalContent) return;

    const isPortrait = videoType === 'instagram' || (
      videoType === 'file' &&
      videoElement &&
      videoElement.videoWidth > 0 &&
      videoElement.videoHeight > videoElement.videoWidth
    );
    videoModal.classList.toggle('video-modal--portrait', isPortrait);
    
    // Clear previous content
    videoModalContent.innerHTML = '';
    
    if (videoType === 'file' && videoElement) {
      // Clone the video element for modal
      const videoClone = videoElement.cloneNode(true);
      videoClone.style.display = 'block';
      videoClone.removeAttribute('controlsList');
      videoClone.setAttribute('controls', 'true');
      videoClone.setAttribute('autoplay', 'true');
      videoModalContent.appendChild(videoClone);
      videoClone.play().catch(function(error) {
        console.log('Video autoplay failed:', error);
      });
    } else if (videoType === 'youtube' && videoId) {
      // Create YouTube iframe
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'true');
      videoModalContent.appendChild(iframe);
    } else if (videoType === 'instagram' && videoId) {
      // Instagram requires its public embed player; query parameters from the
      // merchant-provided URL are deliberately omitted.
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.instagram.com/reel/' + encodeURIComponent(videoId) + '/embed/';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('title', 'Instagram Reel');
      videoModalContent.appendChild(iframe);
    }
    
    videoModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  
  function closeVideoModal() {
    if (!videoModal || !videoModalContent) return;
    
    // Stop any playing videos
    const video = videoModalContent.querySelector('video');
    if (video) {
      video.pause();
      video.src = '';
      video.load();
    }
    
    // Stop YouTube iframe by removing src
    const iframe = videoModalContent.querySelector('iframe');
    if (iframe) {
      iframe.src = '';
    }
    
    // Clear content
    videoModalContent.innerHTML = '';
    
    videoModal.style.display = 'none';
    videoModal.classList.remove('video-modal--portrait');
    document.body.style.overflow = '';
  }
  
  // Close modal events (only close button, not backdrop)
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeVideoModal);
  }
  
  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && videoModal && videoModal.style.display === 'flex') {
      closeVideoModal();
    }
  });
  
  // Play button handling - open modal
  videoItems.forEach(function(item) {
    const playButton = item.querySelector('.video-play-button');
    const videoType = item.dataset.videoType;
    const videoId = item.dataset.videoId;
    const videoPlayer = item.querySelector('.video-player');
    
    if (playButton) {
      playButton.addEventListener('click', function() {
        if (videoType === 'file') {
          const video = videoPlayer ? videoPlayer.querySelector('video') : null;
          openVideoModal('file', null, video);
        } else if (videoType === 'youtube' || videoType === 'instagram') {
          openVideoModal(videoType, videoId, null);
        }
      });
    }
  });
  
  // Disable right-click and download for uploaded videos
  document.querySelectorAll("video.responsive-video").forEach(function (vid) {
    vid.setAttribute("controlsList", "nodownload");
    vid.setAttribute("oncontextmenu", "return false;");
  });
});
  } catch(e) { console.error(e); }
})();

})();
